import { render, staticRenderFns } from "./TaskItemStatic.vue?vue&type=template&id=6358cc17&scoped=true"
import script from "./TaskItemStatic.vue?vue&type=script&lang=ts"
export * from "./TaskItemStatic.vue?vue&type=script&lang=ts"
import style0 from "./TaskItemStatic.vue?vue&type=style&index=0&id=6358cc17&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6358cc17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6358cc17')) {
      api.createRecord('6358cc17', component.options)
    } else {
      api.reload('6358cc17', component.options)
    }
    module.hot.accept("./TaskItemStatic.vue?vue&type=template&id=6358cc17&scoped=true", function () {
      api.rerender('6358cc17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/TaskItemStatic.vue"
export default component.exports